import React from "react";
import PropTypes from "prop-types";
import { PageLayout } from "../../components";
import { InitialOfferHelmet } from "../../components/SellHelmets";
import { PriceIsAGuide } from "../../components/PriceIsAGuide/PriceIsAGuide";
import dayjs from "dayjs";
import { OfferCardInitialValuation } from "./components";
import { PromoHeader } from "../../components/PromoHeader/PromoHeader";
import { useInitialOffer } from "../InitialOffer/useInitialOffer";
import usePromoTicker from "../../hooks/usePromoTicker";
import { ValuationVehicleDetails } from "../../components/ValuationVehicleDetails/ValuationVehicleDetails";
import { MotExpired } from "../../components/MotExpired/MotExpired";

export default function InitialValuation({ onSubmit, showSpinner }) {
  const {
    getStepNumber,
    isPartExchangeCustomer,
    promoActionNotRequired,
    promoApplied,
    showBranchValuationContent,
    showExpired,
    showPromoBranding,
    stepNumber,
    valuation,
    subheaderTitle,
    getAssumptionsAnalytics
  } = useInitialOffer();

  const { handleApplyPromo, showLoader, startTicker } = usePromoTicker();

  const stepNumberProp = getStepNumber(isPartExchangeCustomer, 3, stepNumber);
  const analytics = getAssumptionsAnalytics("initial");
  return (
    <>
      <InitialOfferHelmet />
      <PageLayout>
        <>
          <PageLayout.Header title={subheaderTitle} step={stepNumberProp} />
          <PageLayout.Content
            showPromoBranding={showPromoBranding}
            removeBottomPadding={true}
          >
            <>
              {showPromoBranding && (
                <PromoHeader
                  promotionalBonus={valuation?.promotionalBonus}
                  promoApplied={promoApplied && !showLoader}
                />
              )}
              <ValuationVehicleDetails showPromoBranding={showPromoBranding} />

              <>
                <OfferCardInitialValuation
                  handleApplyPromo={handleApplyPromo}
                  isInitialValuation={true}
                  isPartExchangeCustomer={isPartExchangeCustomer}
                  onSubmit={onSubmit}
                  promoActionNotRequired={promoActionNotRequired}
                  showBranchValuationContent={showBranchValuationContent}
                  showLoader={showLoader}
                  showSpinner={showSpinner}
                  startTicker={startTicker}
                />
                {showExpired && <MotExpired now={dayjs()} />}
              </>
            </>
          </PageLayout.Content>
          <PageLayout.Footer showShadow={false}>
            {valuation && (
              <PriceIsAGuide analytics={analytics} />
            )}
          </PageLayout.Footer>
        </>
      </PageLayout>
    </>
  );
}

InitialValuation.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  showSpinner: PropTypes.bool
};
